/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactElement } from 'react'
import { Extracted } from '../../externals/api/applyRules'
import { toNumeric } from '../../utils/formatter'
import { Container } from './styles'

type CardExamListProps = {
  exams: Extracted[]
  onClickExam?: (examId: string, e: any) => void
}

const CardExamList: FC<CardExamListProps> = ({ exams, onClickExam }): ReactElement => {
  return (
    <Container>
      <h3>Exames identificados</h3>
      <div className='total'>{exams.length}</div>

      {exams.map(exam => (
        <div key={`exam-${exam.name}`} className='flex'>
          <span className='label' title={exam.name}>
            {exam.name}
            {exam.examId && (
              <>
                {' '}
                <button
                  onClick={(e) => onClickExam && onClickExam(exam.examId || '', e)}
                  type='button'
                >
                  Ver histórico
                </button>
              </>
            )}
          </span>
          <span className='text'>{toNumeric(exam.result)} {exam.measurement}</span>
        </div>
      ))}
    </Container>
  )
}

export default CardExamList
